import React, { PureComponent } from 'react'
import c from 'classnames'
import Slider from 'react-slick'

import { DarkNextArrow, DarkPrevArrow } from 'components/ui/SliderArrows'

/*VIEW*/
// import Img from "components/Img";

/*Ui*/
// import Cont from 'components/ui/Cont'

import './style'
import './media'


class OfferSlider extends PureComponent {
    SETTINGS = {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        speed: 300,
        fade: false,
        prevArrow: <DarkPrevArrow />,
        nextArrow: <DarkNextArrow />,
        touchMove: true,
        focusOnSelect: true,
        centerMode: false,
        swipeToSlide: true,
        infinite: true
    }

    render() {
        const { children } = this.props

        return (
            <Slider
                {...this.SETTINGS}
                
                className="offer-slider"
            >
                {children}
            </Slider>
        );
    }
}

const OfferSlide = props => (
    <div className="offer-slide">
        {props.image}
        <div className="container">
            {props.children}
        </div>
    </div>
)

const OfferSliderText = props => (
    <div className={c("offer-slider__text", props.className)}>
        {props.children}
    </div>
)

export { OfferSlide, OfferSliderText }
export default OfferSlider